import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';

export default function TermsOfService() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'DM Sans', sans-serif", backgroundColor: '#FDFBF7' }} data-testid="terms-page">
      <LandingNav />

      <main className="max-w-3xl mx-auto px-6 py-24">
        <h1
          className="mb-4"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300, fontSize: '36px', color: '#3C3226', textTransform: 'uppercase', letterSpacing: '0.1em' }}
          data-testid="terms-title"
        >
          Terms of Service
        </h1>
        <p className="mb-12" style={{ color: '#8C7E6E', fontSize: '13px' }}>Last updated: April 2026</p>

        <div className="space-y-10" style={{ color: '#5C5347', fontSize: '15px', lineHeight: 1.8 }}>
          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }} data-testid="terms-section-overview">1. Overview</h2>
            <p>
              GetChosenFirst ("the Platform," "we," "us," or "our") provides AI presence monitoring,
              optimization tools, and content generation services designed to improve the likelihood that
              AI-powered search and recommendation engines mention or recommend your business.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }} data-testid="terms-section-disclaimer">2. AI Engine Disclaimer</h2>
            <p>
              GetChosenFirst does not control, influence, or have any contractual relationship with
              third-party AI engines including but not limited to ChatGPT (OpenAI), Gemini (Google),
              Claude (Anthropic), Perplexity, Copilot (Microsoft), Grok (xAI), Siri (Apple), or
              Alexa (Amazon). AI engine outputs are determined solely by those platforms' own algorithms,
              training data, and policies.
            </p>
            <p className="mt-4">
              GetChosenFirst does not guarantee any specific ranking, mention, recommendation, or
              placement in any AI-generated response. Results vary based on market conditions, competitor
              activity, the quality and completeness of your business information, and factors outside
              GetChosenFirst's control.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>3. Services Provided</h2>
            <p>We provide the following services:</p>
            <ul className="mt-3 space-y-2 pl-5" style={{ listStyleType: 'disc' }}>
              <li>Scanning 9 AI engines to show you exactly where your business stands.</li>
              <li>Identifying gaps between your current AI presence and what AI engines look for when deciding who to mention.</li>
              <li>Building content, optimizing directory presence, coaching review strategies, and generating technical signals that AI engines use when deciding who to mention.</li>
              <li>Monitoring all 9 engines weekly and alerting you when anything changes.</li>
              <li>Providing tools and signals to help you compete for AI mentions.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>4. Seat Scarcity Model</h2>
            <p>
              GetChosenFirst operates a limited-seat model: a maximum of three (3) professional seats per
              profession per city. Once all seats in a given market are claimed, additional professionals
              in that market will be placed on a waitlist. Seat availability is not guaranteed and is
              offered on a first-come, first-served basis.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>5. Subscription & Billing</h2>
            <p>
              Paid subscriptions are billed monthly or annually as selected at checkout. You may cancel
              your subscription at any time. Cancellation takes effect at the end of the current billing
              period. Refunds are handled on a case-by-case basis at our discretion.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>6. Data & Privacy</h2>
            <p>
              We collect and process business information you provide (business name, location, profession,
              website) to deliver our services. We do not sell your personal data to third parties.
              Scan results, AI engine responses, and generated content are stored securely and used
              solely to provide and improve our services.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, GetChosenFirst shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages, including but not limited to loss
              of revenue, loss of customers, or loss of business opportunity, arising from or related to
              your use of the Platform — regardless of whether such damages were foreseeable.
            </p>
          </section>

          <section>
            <h2 className="mb-4" style={{ color: '#3C3226', fontSize: '18px', fontWeight: 600 }}>8. Changes to Terms</h2>
            <p>
              We reserve the right to update these Terms of Service at any time. Material changes will be
              communicated via email or in-app notification. Continued use of the Platform after changes
              constitutes acceptance of the revised terms.
            </p>
          </section>

          <section className="pt-6" style={{ borderTop: '1px solid #E0DCD3' }}>
            <p style={{ color: '#8C7E6E', fontSize: '13px', fontStyle: 'italic' }}>
              This document is provided for informational purposes and should be reviewed by a qualified
              attorney before relying on it as legal advice. For questions about these terms, contact
              legal@getchosenfirst.com.
            </p>
          </section>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
